import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import AppFooter from "./components/AppFooter";
import AppHeader from "./components/AppHeader";

import { Space } from "@mantine/core";
import PageLoader from "../../components/Loader";
import useRedirectPath from "../../hooks/useRedirectPath";
import useSetActiveYardFromQueryParam from "../../hooks/useSetActiveYardFromQueryParam";
import useBadRouteLog from "./hooks/useBadRouteLog";
import useScrollToTopOnRouteChange from "./hooks/useScrollToTopOnRouteChange";
import classes from "./styles/index.module.css";

type Props = {
  children?: React.ReactNode;
};

export const MainLayout = (props: Props) => {
  useBadRouteLog();
  useRedirectPath();
  useScrollToTopOnRouteChange();
  useSetActiveYardFromQueryParam();

  return (
    <>
      <AppHeader />
      <main className={classes.content}>
        <Suspense fallback={<PageLoader />}>
          <Outlet />
          {props.children}
        </Suspense>
        <Space h="xl" />
      </main>
      <AppFooter />
    </>
  );
};
